import {
  normalizeRegionWorldSnapshot,
  normalizeStarterCacheSummary,
} from '../GroundLoot/groundLoot';
import { normalizeBaseCamp } from '../BaseCamp/baseCamp';

function valueFrom(source, camelName, pascalName) {
  return source?.[camelName] ?? source?.[pascalName];
}

export function normalizeClientBootstrap(payload) {
  const user = valueFrom(payload, 'user', 'User')
    ?? valueFrom(payload, 'clientUser', 'ClientUser')
    ?? null;
  const region = valueFrom(payload, 'region', 'Region') ?? null;
  const regionId = valueFrom(region, 'id', 'Id')
    ?? valueFrom(user, 'currentRegionId', 'CurrentRegionId')
    ?? null;
  const worldInstanceId = valueFrom(
    user,
    'currentWorldInstanceId',
    'CurrentWorldInstanceId',
  ) || 'shared';
  const worldPayload = valueFrom(
    payload,
    'regionWorldState',
    'RegionWorldState',
  )
    ?? valueFrom(payload, 'worldSnapshot', 'WorldSnapshot')
    ?? valueFrom(payload, 'world', 'World')
    ?? {
      regionId,
      worldInstanceId,
      groundLoot: valueFrom(payload, 'groundLoot', 'GroundLoot') ?? [],
      worldLootContainers: valueFrom(
        payload,
        'worldLootContainers',
        'WorldLootContainers',
      ) ?? [],
      generatedAtMs: valueFrom(payload, 'generatedAtMs', 'GeneratedAtMs'),
    };
  const starterCachePayload = valueFrom(
    payload,
    'starterCache',
    'StarterCache',
  );
  const baseCampPayload = valueFrom(payload, 'baseCamp', 'BaseCamp');

  return {
    user,
    region,
    regionWorldState: normalizeRegionWorldSnapshot(
      worldPayload,
      regionId,
      0,
      worldInstanceId,
    ),
    starterCache: normalizeStarterCacheSummary(starterCachePayload),
    baseCamp: normalizeBaseCamp(baseCampPayload),
  };
}
